import { useState } from "react"

export const useCityFormHandling = () => {
    const [formData,setFormData] = useState({
        countryId: "",
        stateId: "",
        districtId: "",
        name: "",
        iplCityId: "",
        active: true,

        countryIdStatus: "unchecked",
        stateIdStatus: "unchecked",
        districtIdStatus: "unchecked",
        nameStatus: "unchecked",
        iplCityIdStatus: "unchecked"

    });    
    
    const handleChange = (event,selectEvent) => {
        
        let formState ={...formData};

        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "countryId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    
                    // clear the state if country is changed
                    formState.stateId = "";
                    formState.stateIdStatus = "unchecked";

                    // clear the district if invalid country
                    formState.districtId = "";
                    formState.districtIdStatus = "unchecked";
                    
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";

                     // clear the state if invalid country
                    formState.stateId = "";
                    formState.stateIdStatus = "unchecked";

                    // clear the district if invalid country
                    formState.districtId = "";
                    formState.districtIdStatus = "unchecked";
                    }

                    break;
                }

                case "stateId": {
                    const alphaNLenghthRegex = /^([\s\S]{1,170})$/;

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                        formState.stateIdStatus = "success";
                    } else {
                        formState.stateIdStatus = event === "" ? "unchecked" : "error";
                    }

                    // reset district
                    formState.districtId = "";
                    formState.districtIdStatus = "unchecked";

                    // set the value
                    formState.stateId = event;

                    break;
                }


                case "districtId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        else if(event && event.target){
            switch(event.target.name){
                case "name": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.nameStatus === "success" &&
        formData.stateIdStatus === "success" &&
        formData.districtIdStatus === "success" &&
        formData.countryIdStatus === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        formData,
        setFormData,
        handleChange,
        checkAllFields
    }
}